module.exports = __webpack_public_path__ + "static/img/4.e021d56d.png";